import React, { useState, useEffect } from "react";

import Hidden from "@material-ui/core/Hidden";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";

import sidebar from "../../../assets/vida-connect-logo.svg";

import {
  titleFinishRegister,
  advanceButton,
  boxButtonChangedPassword,
} from "../style";

export default (props) => {
  const classesFinishRegister = titleFinishRegister();
  const classesButton = advanceButton();
  const classesBoxButton = boxButtonChangedPassword();

  const { userType } = props;
  const [urlToLogin, setUrlToLogin] = useState("");

  useEffect(() => {
    if (userType.indexOf("COMPANY") > -1) {
      setUrlToLogin(`${process.env.REACT_APP_COMPANY}`);
    } else if (userType.indexOf("PROVIDER") > -1) {
      setUrlToLogin(`${process.env.REACT_APP_PROVIDERS}`);
    }
  }, [userType]);

  return (
    <div className="screen">
      <Hidden smDown>
        <div className="sidebar-image">
          <img src={sidebar} alt="Sidebar Vida Connect" />
        </div>
      </Hidden>
      <div className="content">
        <Box className={classesFinishRegister.root}>
          <h1>Senha alterada com sucesso</h1>
        </Box>
        <Box className={classesBoxButton.root}>
          <a href={urlToLogin}>
            <Button className={classesButton.root}>OK</Button>
          </a>
        </Box>
      </div>
    </div>
  );
};
